import React, { Fragment } from 'react';
import { useQuery } from "react-query";
import { Link } from 'react-router-dom';

import { ButtonsRow, Column, ColumnContainer, Divider, MainButton, SectionTitle, TileSlider, TitleContainer } from "@beacharound/beacharound-ui";
import { formatDate } from "@beacharound/beacharound-ui-helpers";
import { getEvents } from '../../api/events';

export default function BeachesEventsSlider({match}) {

    const { beachSlug } = match.params;

    const eventsFromDate = formatDate(new Date(), 'yyyy-MM-dd');
    const eventsParams = {
        fromDate: eventsFromDate,
        sort: {date: 1},
        limit: 10
    }
    const { data: events } = useQuery(["events", beachSlug, eventsParams], () =>
        getEvents({ activitySlug: beachSlug, params: eventsParams}),
        {
            enabled: !!beachSlug
        }
    )

    if(!events || events.length <= 0 || !Array.isArray(events)) {
        return <Fragment></Fragment>
    }

    return (
        <ColumnContainer noMargin>
            <Column>
                <TitleContainer>
                    <SectionTitle text="Prossimi eventi" />
                </TitleContainer>
                <ColumnContainer noMargin>
                    <Column>
                        <TileSlider slides={events.map(item => {
                            const isBookable = item?.typeOfAccess === "LIMITED";
                            const subtext = !isBookable && "<strong>Evento gratuito ad ingresso libero</strong>";
                            return {
                                title: item.name,
                                subtext,
                                pretitleColor: "main",
                                pretitle: item?.startDate && formatDate(item.startDate, 'dd MMMM'),
                                highlight: isBookable && "Evento prenotabile online!"
                            }
                        })} />
                    </Column>
                </ColumnContainer>
                <ButtonsRow fill marginBottom>
                    <MainButton
                        border
                        text="Scopri tutti gli eventi"
                        component={Link}
                        to={`${match.url}/eventi-e-feste-in-spiaggia`}
                    />
                </ButtonsRow>
                <Divider  />
            </Column>
        </ColumnContainer>
    );
}